var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,null,{
      members: _vm.members,
      page: _vm.page,
      lastPage: _vm.lastPage,
      next: _vm.next
    })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }